// extracted by css-extract-rspack-plugin
export default {"root":"jQn7dn"};